import { useQuery, QueryOptions } from '@tanstack/react-query';
import { API } from '../constants/constants';

const DROPDOWN_TABLE_REFRESH_MS = 45 * 1000;

export const useDropdownTable = (options: QueryOptions) =>
  useQuery({
    queryFn: async () => (await API.get('dropdown-table')).data,
    queryKey: ['dropdown-table'],
    refetchInterval: DROPDOWN_TABLE_REFRESH_MS,
    ...options,
  });
